import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from "./registerServiceWorker";
import './App.css';
import {Provider} from 'react-redux';
import ConfigStore from './config/config-store';
import { HashRouter } from 'react-router-dom';

const store = ConfigStore();

ReactDOM.render(
    <Provider store={store}>
        <HashRouter>
            <App/>
        </HashRouter>
    </Provider>,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();
